import db from '@/functions/idb'
import api from '@/functions/api'
import Protocol from '@/classes/protocol'
import axios from 'axios'

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_UPDATE = 'USER_UPDATE'

export default {
  newProtocol (context) {
    return new Protocol()
  },
  async saveProtocol (context, {protocol, local, sendMails = false}) {
    protocol.draft = local
    if (!local && navigator.onLine) {
      try {
        let response = await api.updateProtocol(protocol, sendMails)
        await db.deleteProtocol(protocol)
        return response
      } catch (err) {
        console.log(err)
        return db.updateProtocol(protocol)
      }
    } else {
      return db.updateProtocol(protocol)
    }
  },
  async getProtocols (context, {local, page, filters}) {
    return db.getProtocols()
  },
  async getProtocol (context, {id, local}) {
    return local ? db.getProtocol(id) : api.getProtocol(id)
  },
  async getProtocolWhereApiID (context, {id}) {
    return db.getProtocolWhereApiID(id)
  },
  deleteProtocolFromIdb (context, {protocol}) {
    return db.deleteProtocol(protocol)
  },
  [USER_REQUEST]: ({commit, dispatch}) => {
    commit(USER_REQUEST)
    axios({url: 'auth/user', method: 'GET'})
      .then(resp => {
        localStorage.setItem('user', JSON.stringify(resp.data))
        commit(USER_SUCCESS, resp.data)
      })
      .catch(() => {
        commit(USER_ERROR)
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT)
      })
  },
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios({url: 'auth/login', data: user, method: 'POST'})
        .then(resp => {
          const token = resp.data.token.token
          const tokenType = resp.data.token.token_type
          localStorage.setItem('user-token', tokenType + ' ' + token)
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          axios.defaults.headers.common['Authorization'] = tokenType + ' ' + token
          commit(AUTH_SUCCESS, token)
          commit(USER_SUCCESS, resp.data.user)
          commit('modalAuthError', false)
          resolve(resp)
        })
        .catch(error => {
          commit(AUTH_ERROR, error.response.data.message)
          localStorage.removeItem('user-token')
          reject(error.response.data.message)
        })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      axios({url: 'auth/logout', method: 'POST'})
        .then(resp => {
          commit(AUTH_LOGOUT)
          localStorage.removeItem('user-token')
          localStorage.removeItem('user')
          // remove the axios default header
          delete axios.defaults.headers.common['Authorization']
          resolve()
        })
        .catch(error => {
          commit(AUTH_LOGOUT)
          localStorage.removeItem('user-token')
          localStorage.removeItem('user')
          delete axios.defaults.headers.common['Authorization']
          console.log(error)
          reject(error)
        })
    })
  },
  [AUTH_ERROR]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('user-token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js